import { Outlet } from 'react-router-dom';

import UnauthenticatedLayout from '@components/UnauthenticatedLayout';
import LoginPage from '@pages/auth/login';
import MagicLinkPage from '@pages/auth/magic-link';
import RegisterPage from '@pages/auth/register';

export const authRoutes = {
  path: 'auth',
  element: (
    <UnauthenticatedLayout>
      <Outlet />
    </UnauthenticatedLayout>
  ),
  children: [
    { path: 'login', element: <LoginPage /> },
    { path: 'register', element: <RegisterPage /> },
    { path: 'magic-link', element: <MagicLinkPage /> },
  ],
};
